module.exports = __webpack_public_path__ + "_assets/img/info-icon.889bb538.svg";